export default __webpack_public_path__ + "static/media/delivery23grey.ba9f61e1.svg";